import { Client } from '@viddsee/server-api-client';
import { baseConfiguration } from './webcall-base';

export const loginApi = new Client.LoginApi(baseConfiguration);
